import { Flex, Typography } from "antd";
import { ROUTES } from "Constants/AllRoutes";
import { useUserInfo } from "GlobalStates/User";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { user } = useUserInfo();
  const location = useLocation();
  if (location.pathname.includes(ROUTES.PROFILE_FORM)) {
    if (!user?.token) {
      return <Navigate to="/" />;
    }
    if (user?.hasCompletedProfile) {
      return <Navigate to={ROUTES.MY_CALENDAR} />;
    }
    return children;
  }

  if (location.pathname.includes(ROUTES.REGISTER_ROLE)) {
    if (!user?.token) {
      return <Navigate to="/" />;
    }
    if (user?.hasCompletedProfile) {
      return <Navigate to={ROUTES.MY_CALENDAR} />;
    }
    return children;
  }
  if (!user?.token) {
    return <Navigate to="/" />;
  }
  if (!user?.hasCompletedProfile) {
    return <Navigate to={ROUTES.REGISTER_ROLE} />;
  }
  return children;
};

export const VerifiedUserProtectedRoute = ({ children }) => {
  const { user } = useUserInfo();
  const { Title } = Typography;
  if (!user?.isVerified) {
    return (
      <Flex justify="center" align="center" style={{ height: "100%" }}>
        <Title level={3}>Please wait while we verify your account</Title>
      </Flex>
    );
  }
  return children;
};
